/* eslint-disable */
import * as Types from "./types";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type GqlMatterPermissionsQueryVariables = Types.Exact<{
  matterIds:
    | Array<Types.Scalars["String"]["input"]>
    | Types.Scalars["String"]["input"];
}>;

export type GqlMatterPermissionsQuery = {
  __typename: "Query";
  matterPermissions: Array<{
    __typename: "MatterPermission";
    matterId: string;
    canAccess: boolean;
  }>;
};

export const MatterPermissionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "matterPermissions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "matterIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "matterPermissions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "matterIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "matterIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "matterPermissionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "matterPermissionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MatterPermission" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "matterId" } },
          { kind: "Field", name: { kind: "Name", value: "canAccess" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GqlMatterPermissionsQuery,
  GqlMatterPermissionsQueryVariables
>;
